module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionWawj.d7e1801f.png";